import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Stack)`
  border-top: 1px dashed ${(p) => p.theme.palette.primary[200]};
  border-bottom: 1px solid ${(p) => p.theme.palette.primary[200]};
  background: ${(p) => p.theme.palette.primary[50]};
  padding: ${(p) => p.theme.spacing(1, 5.5)};
`;
